import React from 'react'
import { connect } from 'react-redux'
import { selectors } from './store/modules/initial'

const { getInitialReadyStatus } = selectors

export default function withStateReadyCheck(WrappedComponent) {
  return connect(state => ({
    $ready: getInitialReadyStatus(state),
  }))(props => {
    const { $ready } = props
    return <React.Fragment>{$ready && <WrappedComponent {...props} />}</React.Fragment>
  })
}
